import { LivepeerConfig, createReactClient, studioProvider } from '@livepeer/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BroadcastComponent from './components/Broadcast';
import Viewer from './components/Viewer';
import Header from './components/Header';
import './App.css';

const ErrorDisplay = ({ title, message, details }) => (
  <div className="App">
    <header className="App-header" style={{ color: 'white', backgroundColor: '#282c34', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <h2>{title}</h2>
      <p>{message}</p>
      {details && <pre style={{ maxWidth: '80%', overflow: 'auto', background: '#1a1a1a', padding: '15px', borderRadius: '5px' }}>{JSON.stringify(details, null, 2)}</pre>}
    </header>
  </div>
);

// Add detailed console logging for debugging
const envDetails = {
  apiKey: process.env.REACT_APP_LIVEPEER_API_KEY ? 'Present' : 'Missing',
  apiKeyLength: process.env.REACT_APP_LIVEPEER_API_KEY?.length,
  nodeEnv: process.env.NODE_ENV,
  origin: window.location.origin,
  buildTime: process.env.REACT_APP_BUILD_TIME || 'Not set'
};

console.log('Environment Details:', envDetails);

let client;
let clientError;

try {
  if (!process.env.REACT_APP_LIVEPEER_API_KEY) {
    throw new Error('Livepeer API key is not configured');
  }
  
  client = createReactClient({
    provider: studioProvider({
      apiKey: process.env.REACT_APP_LIVEPEER_API_KEY,
      baseUrl: 'https://livepeer.studio/api'
    }),
  });
} catch (error) {
  console.error('Error creating Livepeer client:', error);
  clientError = error;
}

function App() {
  if (!process.env.REACT_APP_LIVEPEER_API_KEY) {
    return (
      <ErrorDisplay
        title="Configuration Error"
        message="Livepeer API key is not configured."
        details={envDetails}
      />
    );
  }

  if (clientError) {
    return (
      <ErrorDisplay
        title="Initialization Error"
        message="There was an error creating the Livepeer client."
        details={{ error: clientError.message, ...envDetails }}
      />
    );
  }

  if (!client) {
    return (
      <ErrorDisplay
        title="Client Error"
        message="Failed to initialize Livepeer client."
        details={envDetails}
      />
    );
  }

  return (
    <LivepeerConfig client={client}>
      <Router>
        <div className="App">
          <Header />
          <main className="app-main">
            <Routes>
              <Route path="/" element={<BroadcastComponent />} />
              <Route path="/watch" element={<Viewer />} />
            </Routes>
          </main>
        </div>
      </Router>
    </LivepeerConfig>
  );
}

export default App;